import { gql } from '@apollo/client';

export const CREATE_BRANDED_INVITE = gql`
  mutation createBrandedInvite($body: Body!) {
    inspectionTemplate(body: $body)
      @rest(
        type: "BrandedInvite"
        method: "POST"
        path: "/brandedInvitation/create"
        endpoint: "users"
        bodyKey: "body"
      ) {
      result
    }
  }
`;
